// extracted by mini-css-extract-plugin
export default {"landingPage":"NamePrompt_landingPage__APC+f","fillDetailBox":"NamePrompt_fillDetailBox__LjvtJ","buttonsDiv":"NamePrompt_buttonsDiv__u6ZbS"};